import { api } from "@/lib/api";

// Devuelve { id, url, content_type, kind, size } o lanza Error con mensaje legible
export async function uploadFile(file, onProgress) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/uploads", form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
    },
  });
  return data;
}

// Construye la URL absoluta servida desde el backend (compatible con <img src>)
export function fileSrc(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  return `${base}${url}`;
}
